export interface IFetchStartedAction {
  type: 'IFetchStarted';
}

export interface IFetchFinishedAction {
  type: 'IFetchFinished';
}

export function fetchStarted(): IFetchStartedAction {
  return {
    type: 'IFetchStarted',
  };
}

export function fetchFinished(): IFetchFinishedAction {
  return {
    type: 'IFetchFinished',
  };
}

export type Action = IFetchStartedAction | IFetchFinishedAction;
